import { Role } from '@/model/entities';
import useAuthStore from '@/store/authStore';
import React from 'react';
import { Navigate } from 'react-router';

interface ProtectedRouteProps {
  children: React.ReactNode;
  role: Role;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, role }) => {  
  const { user, userRole } = useAuthStore();

  if (!user || !userRole) {
    // Redirect to the login page if the user is not authenticated,
    // preserving the current location so you can send them back after login.
    return <Navigate to="/auth" replace />;
  }

  if (userRole !== role) {  
      return <Navigate to="/access-denied" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;